import axios from "axios";
import qs from "qs";

const state = {
  offices: [],
  highlighted: [],
  listType: "offices"
};

const getters = {
  officeList(state) {
    return state.listType === "offices" ? state.offices : state.highlighted;
  }
};

const mutations = {
  setOffices(state, data) {
    state.offices = data;
  },
  toggleListType(state) {
    state.listType = state.listType === "offices" ? "cart" : "offices";
  },
  toggleOffice(state, office) {
    const index = state.highlighted.findIndex(o => o.id === office.id);
    if (index === -1) {
      state.highlighted = [...state.highlighted, office];
    } else {
      state.highlighted = state.highlighted.filter(o => o.id !== office.id);
    }
    if (state.highlighted.length === 0) {
      state.listType = "offices";
    }
  },
  deselectAll() {
    state.listType = "offices";
    state.highlighted = [];
  },
  replace(state, id) {
    state.highlighted = [id];
  }
};

const actions = {
  fetchOffices(context, query) {
    return new Promise(resolve => {
      axios.get(`offices/search?${qs.stringify(query)}`).then(response => {
        context.commit("setOffices", response.data);
        resolve(response);
      });
    });
  },
  async officeById(context, id) {
    const office = await axios.get(
      `offices/${id}?populate[0]=mainImage&populate[1]=gallery&populate[2]=offeredServices`
    );
    return { ...office?.data?.data?.attributes, id: office?.data?.data?.id };
  },
  askOffer(context, data) {
    return new Promise(resolve => {
      axios.post("inquiries", { data }).then(response => {
        resolve(response);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
